import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import { Grid, Link, Paper } from "@mui/material";
import authoritySignature from "assets/images/authoritySignature.png";
import IfanFlexLogo from "assets/images/ifanFlexLogo.png";
import RupeesSymbol from "assets/images/rupees_symbol.jpg";
import jobizoLogo from "assets/images/jobizoLogo.png";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import jsPDF from "jspdf";
// import html2canvas from 'html2canvas';
//import htmlToPdf from 'html-pdf';
// import html2pdf from 'html2pdf.js';

import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchBillData } from "../Redux/actionCreator";
import "./GigBillStyle.css";
import { transactionSlice } from "./../../transaction/Redux/reducer";
import { toast } from "react-toastify";

const GigBillTax = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { adminData } = useSelector((state) => ({
    adminData: state?.auth?.adminData,
  }));

  const { Bill_Data } = useSelector((state) => state.bills);
  var gigBillData = Bill_Data?.billInfo;

  // console.log("gigBillData>>>", gigBillData);

  const path2 = window.location.pathname.split("view1/")[1];
  //   console.log("path2", path2);

  const userInvoiceData = gigBillData[0]?.userInvoices
    ? gigBillData[0]?.userInvoices
    : [];

  const convert = (str) => {
    var date = new Date(str),
      month = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);

    return [day, month, date.getFullYear()].join("-");
  };

  const lastPart = gigBillData[0]?.billNumber.split("/").pop();
  //   console.log("lastPart>>",lastPart)

  async function printDocument1() {
    let jsPdf = new jsPDF("p", "pt", "letter");
    var htmlElement = document.getElementById("invoiceContainer1");
    const opt = {
      callback: function (jsPdf) {
        jsPdf.save(`${lastPart}.pdf`);
        window.open(jsPdf.output("bloburl"));
      },
      margin: 10,
      autoPaging: "text",
      html2canvas: {
        allowTaint: true,
        dpi: 300,
        letterRendering: true,
        logging: false,
        scale: 0.45,
      },
    };

    jsPdf.html(htmlElement, opt);
  }

  const handleBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    dispatch(fetchBillData(path2));
  }, [path2, dispatch]);

  const Part1 = gigBillData[0]?.billNumber.split("/").slice(-3, -2)[0];
  const Part2 = gigBillData[0]?.billNumber
    .split("/")
    .slice(-2, -1)[0]
    .replace("-", "");
  const Part3 = gigBillData[0]?.billNumber.split("/").pop();
  const transformedPart = isNaN(Part3) ? Part3 : "D" + Part3;
  const result = Part1 + "/" + Part2 + "/" + transformedPart;
  // let debitNumber = gigBillData[0]?.billNumber;
  let debitNumber = result;

  // console.log(">>", gigBillData);
  let invoiceAmount =
    gigBillData[0]?.convensionFee +
    gigBillData[0]?.cgst +
    gigBillData[0]?.sgst +
    gigBillData[0]?.gst;

  // console.log("total", invoiceAmount);
  console.log("taxInvoiceDetails", gigBillData[0]);

  const handleDownloadData = async () => {
    const hasExportPermission =
      adminData?.isSuperAdmin ||
      adminData?.permissions?.some(
        (item) => item.module === "bill" && item.actions.includes("export")
      );
    if (hasExportPermission) {
      try {
        //phle aesa tha
        // const jsPdf = new jsPDF({
        //   orientation: "portrait",
        //   unit: "px",
        //   hotfixes: ["px_scaling"],
        //   format: [1200, 800],
        // });
        const pdfContent = `
          
          <!DOCTYPE html>
          <html lang="en">
          
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Your Page Title</title>
            <style>
          .invoiceHeader{
              display: flex;
              justify-content: space-between;
              align-content: center;
          }
          .headerContent{
              text-align-last: end;
          }
          table, th, td {
              border: 1px solid black;
              border-collapse: collapse;
              padding: 5px;
              height: 5px;
            }
            th {
              text-align: left;
              height: 5px;
          
            }
            .textAlignmentCenter{
              text-align-last: center;
            }
            .textAlignmentRight{
              text-align-last: end;
            }
            .textFit{
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            .notePoint{
              font-weight: bold;
            }
          

            * {
                  margin:0;
                  padding:0;
                  font-family:"Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                  color:  #001f3f;
                }
                .hr-line {
  width: 100%;
  margin: 0.5em 0;
  border-top: 1px solid #000;
  }
    
          
            </style>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/jszip/3.7.1/jszip.min.js"></script>
          </head>
          
          <body >
            <div style="max-width: fit-content; font-size: 12.8px;">
              <div  style= "page-break-before: always; margin-top: 1rem; border: 1px solid black;width: 800px;height: auto;padding: 15px; margin: auto;">
                <div class="invoiceHeader">
                  <img src="${IfanFlexLogo}" alt="logo" style="width: 25%;height: 10%; align-self: end;"/>
                  <div class="headerContent">
                    <h4>Duplicate Copy</h4><br />
                  <small>Plot No.89, 3 Floor, Sector 44</small>
                  <br />
                  <small>Gurgaon - 122003, Haryana (India)</small>
                  <br />
                  <small>Email: info@jobizo.com</small>
                  <hr />
                  <small>Reg. Office: H-294, Plot 2A, First Floor,</small>
                  <br />
                  <small>Singh Estate, Saidulajab, Lane No.2,</small>
                  <br />
                  <small>Saket New Delhi 110030</small>
                  </div>
                </div>
                <br />
                <table>
                  <tbody>
                    <tr>
                      <th colspan="3" style="background-color: lightgrey; text-align: center;width:800px;margin-right: 50px;">
                        TAX INVOICE
                      </th>
                    </tr>
                    <tr>
                      <th>Service Provider</th>
                      <th>Invoice No.</th>
                      <th>Dated</th>
                    </tr>
                    <tr>
                      <td>IFAN Flex Pvt. Ltd.</td>
                      <td>${gigBillData[0]?.billNumber}</td>
                      <td>
                        ${moment(gigBillData[0]?.billingDate)
                          .utc()
                          .format("DD-MM-YYYY")}
                        
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Works:Plot No 89, 3rd Floor, Sector 44 Gurugram <br />
                        122003
                      </td>
                      <td colSpan="2">
                        Tax Registration
                        <br />
                        PAN:AAFCI9183G
                        <br />
                        GSTN:06AAFCI9183G1ZB
                        <br />
                        CIN:U74999DL2020PTC373866
                      </td>
                    </tr>
                    <tr>
                      <th>Client:</th>
                      <th colSpan="2">Bank Details:</th>
                    </tr>
                    <tr>
                      <td>
                         ${
                           gigBillData[0]?.branch?.billingInfo?.gstDetails
                             ?.billingName
                             ? gigBillData[0]?.branch?.billingInfo?.gstDetails
                                 ?.billingName + ","
                             : ""
                         }
                       <br />
                       Official Address: ${
                         gigBillData[0]?.branch?.billingInfo?.gstDetails
                           ?.billingAddress
                           ? gigBillData[0]?.branch?.billingInfo?.gstDetails
                               ?.billingAddress + ","
                           : ""
                       }
                      
                      ${
                        gigBillData[0]?.branch?.billingInfo?.gstDetails
                          ?.billingCity
                          ? gigBillData[0]?.branch?.billingInfo?.gstDetails
                              ?.billingCity + ","
                          : ""
                      }
                      ${
                        gigBillData[0]?.branch?.billingInfo?.gstDetails
                          ?.billingState
                          ? gigBillData[0]?.branch?.billingInfo?.gstDetails
                              ?.billingState + ","
                          : ""
                      }
                      ${
                        gigBillData[0]?.branch?.billingInfo?.gstDetails
                          ?.billingCountry
                          ? gigBillData[0]?.branch?.billingInfo?.gstDetails
                              ?.billingCountry
                          : ""
                      }
                        <br />
                        ${
                          gigBillData[0]?.branch?.billingInfo?.gstDetails
                            ?.billingPinCode || ""
                        }
                      </td>
          
                      <td rowSpan="1" colSpan="2">
                        IfanFlex Pvt. Ltd
                        <br />
                        ICICI Bank Ltd.
                        <br />
                        Account No. : 402105000512
                        <br />
                        Branch: NDSE-I, South Extension New Delhi-110049
                        <br />
                        IFSC:ICIC0004021
                      </td>
                    </tr>
                    <tr>
                      <td>
                        State Code: ${gigBillData[0]?.stateCode}
                        <br />
                        Reverse charges applicable:${
                          gigBillData[0]?.buyer?.reverseChargesApplicable
                        }
                        <br />
                        GSTIN: ${gigBillData[0]?.buyer?.gst || "NA"}
                      </td>
                    
                      <td colspan="2" style="padding: 5px; font-size: 13px; color:#000;">
 
  <div style="display: flex; justify-content: space-between; padding: 3px 0;">
    <span>Payment Due Date :</span>
    <span>${moment(gigBillData[0]?.billingDate)
      .utc()
      .add(parseInt(gigBillData[0]?.buyer?.paymentDueDate), "days")
      .format("MMMM D, YYYY")}</span>
  </div>
</td>

  


                  <tr>
  <th class="textAlignmentCenter">S.no.</th>
  <th class="textAlignmentCenter">Description of Service</th>
  <th class="textAlignmentCenter">Amount</th>
</tr>

<tr>
  <td class="textAlignmentCenter">1</td>
  <td class="textFit">
    Convenience fee of the month of
    ${moment(gigBillData[0]?.billingDate).utc().format("MMMM YYYY")}
  </td>
  <td style="text-align:right; margin:0; padding:0;">
    <img src="${RupeesSymbol}" alt="Rupees" style="height:20px; width:20px; display:inline-block; vertical-align:middle;" />
    <span style="display:inline-block; vertical-align:middle;">${gigBillData[0]?.convensionFee.toLocaleString(
      "en-IN",
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
    )}</span>
  </td>
</tr>

<tr>
  <td></td>
  <td>Sub Total</td>
  <td style="text-align:right; margin:0; padding:0;">
    <img src="${RupeesSymbol}" alt="Rupees" style="height:20px; width:20px; display:inline-block; vertical-align:middle;" />
    <span style="display:inline-block; vertical-align:middle;">${gigBillData[0]?.convensionFee.toLocaleString(
      "en-IN",
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
    )}</span>
  </td>
</tr>

${
  !gigBillData[0]?.cgst || !gigBillData[0]?.sgst
    ? `
      <tr>
        <td colspan="2"><b>Add: CGST @ 9%</b></td>
        <td class="textAlignmentRight">-</td>
      </tr>
      <tr>
        <td colspan="2"><b>Add: SGST @ 9%</b></td>
        <td class="textAlignmentRight">-</td>
      </tr>
      <tr>
        <td colspan="2"><b>Add: IGST @ 18%</b></td>
        <td style="text-align:right;">
          <img src="${RupeesSymbol}" alt="Rupees" style="height:20px; width:20px; display:inline-block; vertical-align:middle;" />
          <span style="display:inline-block; vertical-align:middle;">${gigBillData[0]?.gst.toLocaleString(
            "en-IN",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          )}</span>
        </td>
      </tr>
    `
    : `
      <tr>
        <td colspan="2"><b>Add: CGST @ 9%</b></td>
        <td style="text-align:right;">
          <img src="${RupeesSymbol}" alt="Rupees" style="height:20px; width:20px; display:inline-block; vertical-align:middle;" />
          <span style="display:inline-block; vertical-align:middle;">${gigBillData[0]?.cgst.toLocaleString(
            "en-IN",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          )}</span>
        </td>
      </tr>
      <tr>
        <td colspan="2"><b>Add: SGST @ 9%</b></td>
        <td style="text-align:right;">
          <img src="${RupeesSymbol}" alt="Rupees" style="height:20px; width:20px; display:inline-block; vertical-align:middle;" />
          <span style="display:inline-block; vertical-align:middle;">${gigBillData[0]?.sgst.toLocaleString(
            "en-IN",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          )}</span>
        </td>
      </tr>
      <tr>
        <td colspan="2"><b>Add: IGST @ 18%</b></td>
        <td class="textAlignmentRight">-</td>
      </tr>
    `
}

<tr>
  <td colspan="2"><b>Total</b></td>
  <td style="text-align:right; margin:0; padding:0;">
    <img src="${RupeesSymbol}" alt="Rupees" style="height:20px; width:20px; display:inline-block; vertical-align:middle;" />
    <span style="display:inline-block; vertical-align:middle;">${invoiceAmount.toLocaleString(
      "en-IN",
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
    )}</span>
  </td>
</tr>

          
                    
                  </tbody>
                </table>
                <div style="margin-top: 10px;">
                 <b>
  Note <br /> * TDS to be deducted at @
  ${gigBillData[0]?.branch?.tds ? gigBillData[0]?.branch?.tds : 2}
  % under ${gigBillData[0]?.branch?.tds === 10 ? "194J" : "194C"}
</b>
                 <br />
                   <b>Terms & Conditions:</b>
             <div >
  <ol style="list-style-type: decimal; padding-left: 35px;">
    <li style="margin: 6px 0; padding-left: 12px;">
      Subject to 'Delhi' Jurisdiction only.
    </li>
    <li style="margin: 6px 0; padding-left: 12px;">
      Please send the relevant TDS Certificate asap.
    </li>
    <li style="margin: 6px 0; padding-left: 12px;">
      Service Accounting Code: ${gigBillData[0]?.sac}.
    </li>
    <li style="margin: 6px 0; padding-left: 12px;">
      Late Payment Fees of 1.5% per month would be charged after due date.
    </li>
    <li style="margin: 6px 0; padding-left: 12px;">
      Invoice raised will be deemed to be correct and accepted by you unless any
      discrepancy is reported to us in writing, within 7 days from the date of
      receipt of the Invoice.
    </li>
  </ol>
</div>

                   <div class="page-break signature-block">
                     <p style="font-style: italic;">For IFAN Flex Pvt. Ltd.</p>
                     <img
                       src=${authoritySignature}
                       alt="logosign"
                       style="width: 10%;height: 10%;align-self: end;margin: 6px;"
                     /><br/>
                     <p style=" padding: 5px;font-size: 15px;color: grey;font-style: italic;">
                     No Signature required as it's a system generated Tax Invoice
                     </p>
                   </div>
                   <hr />
                   <div style="font-style: italic; font-size: 13px; display: flex; display: flex;justify-content: space-around;color: rgb(175, 171, 171); padding: 5px; ">
                     <p>Office: +91 124.487 5800</p>
                     <p>Fax : +91 124.401 4035</p>
                     <p>CIN: U74999DL2020PTC373866</p>
                   </div>
                 </div>
                <br />
              </div>
          

                
              </div>
            </div>
          </body>
          
          </html>
          
                    `;
        //ab aes kar diya
        const tempDiv = document.createElement("div");
        tempDiv.style.position = "absolute";
        tempDiv.style.left = "-9999px";
        tempDiv.innerHTML = pdfContent;
        document.body.appendChild(tempDiv);
        const contentWidth = tempDiv.scrollWidth;
        const contentHeight = tempDiv.scrollHeight;
        // console.log("Content Size:", contentWidth, contentHeight);
        document.body.removeChild(tempDiv);
        const jsPdf = new jsPDF({
          orientation: "portrait",
          unit: "px",
          hotfixes: ["px_scaling"],
          format: [contentWidth, contentHeight + 40],
        });
        await new Promise((resolve, reject) => {
          jsPdf.html(pdfContent, {
            callback: (pdf) => {
              pdf.save(`${lastPart}.pdf`);
              window.open(jsPdf.output("bloburl"));
              resolve();
            },
            x: 0,
            y: 0,
            html2canvas: {
              scale: 1,
              windowWidth: contentWidth,
              windowHeight: contentHeight,
            },
          });
        });
      } catch (error) {
        console.error("Error generating PDFs:", error);
      }
    } else {
      toast.error("Access Denied: You don't have permission to export data");
    }
  };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox m={2}>
          <Grid item xs={12} display="flex" justifyContent="space-between">
            <div style={{ display: "flex", width: "70px" }}>
              <Link onClick={handleBack}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <ArrowBackIos fontSize="small" />
                  back
                </div>
              </Link>
            </div>

            <MDButton
              variant="contained"
              color="info"
              onClick={() => {
                // printDocument1();
                handleDownloadData();
              }}
            >
              Export as PDF
            </MDButton>
          </Grid>
        </MDBox>
        <div id="invoiceContainer1">
          <Paper sx={{ marginTop: "1rem" }}>
            <MDBox className={"invoiceBox"}>
              <div className="invoiceHeader">
                <img src={IfanFlexLogo} alt="logo" className="logoStyle" />

                <div className="headerContent">
                  <h4>Duplicate Copy</h4>
                  <br />
                  <small>Plot No.89, 3 Floor, Sector 44</small>
                  <br />
                  <small>Gurgaon - 122003, Haryana (India)</small>
                  <br />
                  <small>Email: info@jobizo.com</small>
                  <hr />
                  <small>Reg. Office: H-294, Plot 2A, First Floor,</small>
                  <br />
                  <small>Singh Estate, Saidulajab, Lane No.2,</small>
                  <br />
                  <small>Saket New Delhi 110030</small>
                </div>
              </div>
              <br />
              <br />

              <table>
                <tbody>
                  <tr>
                    <th
                      colSpan={3}
                      style={{
                        backgroundColor: "lightgrey",
                        textAlign: "center",
                      }}
                    >
                      TAX INVOICE
                    </th>
                  </tr>
                  <tr>
                    <th>Service Provider</th>
                    <th>Invoice No.</th>
                    <th>Dated</th>
                  </tr>
                  <tr>
                    <td>IFAN Flex Pvt. Ltd.</td>
                    <td>{gigBillData[0]?.billNumber}</td>
                    <td>
                      {moment(gigBillData[0]?.billingDate)
                        .utc()
                        .format("DD-MM-YYYY")}{" "}
                      &nbsp; &nbsp; &nbsp;
                    </td>
                  </tr>

                  <tr>
                    <td>
                      Works: Plot No 89, 3rd Floor, Sector 44 <br />
                      Gurugram 122003
                    </td>
                    <td colSpan={2}>
                      Tax Registration
                      <br />
                      PAN:AAFCI9183G
                      <br />
                      GSTN:06AAFCI9183G1ZB
                      <br />
                      CIN:U74999DL2020PTC373866
                    </td>
                  </tr>
                  <tr>
                    <th>Client:</th>
                    <th colSpan={2}>Bank Details:</th>
                  </tr>
                  <tr>
                    <td>
                      {gigBillData[0]?.branch?.billingInfo?.gstDetails
                        ?.billingName
                        ? gigBillData[0]?.branch?.billingInfo?.gstDetails
                            ?.billingName + ","
                        : ""}
                      <br />
                      {gigBillData[0]?.branch?.billingInfo?.gstDetails
                        ?.billingAddress
                        ? gigBillData[0]?.branch?.billingInfo?.gstDetails
                            ?.billingAddress + ","
                        : ""}{" "}
                      &nbsp;
                      {gigBillData[0]?.branch?.billingInfo?.gstDetails
                        ?.billingCity
                        ? gigBillData[0]?.branch?.billingInfo?.gstDetails
                            ?.billingCity + ","
                        : ""}{" "}
                      &nbsp;
                      {gigBillData[0]?.branch?.billingInfo?.gstDetails
                        ?.billingState
                        ? gigBillData[0]?.branch?.billingInfo?.gstDetails
                            ?.billingState + ","
                        : ""}{" "}
                      &nbsp;
                      {
                        gigBillData[0]?.branch?.billingInfo?.gstDetails
                          ?.billingCountry
                      }
                      <br />
                      {
                        gigBillData[0]?.branch?.billingInfo?.gstDetails
                          ?.billingPinCode
                      }
                    </td>
                    {/* <td>
                      {gigBillData[0]?.buyer?.address?.hospitalName
                        ? gigBillData[0]?.buyer?.address?.hospitalName + ","
                        : ""}
                      <br />
                      Official Address:{" "}
                      {gigBillData[0]?.buyer?.address?.address?.address
                        ? gigBillData[0]?.buyer?.address?.address?.address + ","
                        : ""}
                      &nbsp;
                      {gigBillData[0]?.buyer?.address?.address?.city
                        ? gigBillData[0]?.buyer?.address?.address?.city + ","
                        : ""}{" "}
                      &nbsp;
                      {gigBillData[0]?.buyer?.address?.address?.state
                        ? gigBillData[0]?.buyer?.address?.address?.state + ","
                        : ""}{" "}
                      &nbsp;
                      {gigBillData[0]?.buyer?.address?.address?.country}
                      <br />
                      {gigBillData[0]?.buyer?.address?.address?.pin}
                    </td> */}

                    <td rowSpan={1} colSpan={2}>
                      IfanFlex Pvt. Ltd
                      <br />
                      ICICI Bank Ltd.
                      <br />
                      Account No. : 402105000512
                      <br />
                      Branch: NDSE-I, South Extension New Delhi-110049
                      <br />
                      IFSC:ICIC0004021
                    </td>
                  </tr>
                  <tr>
                    <td rowSpan={1} colSpan={1}>
                      State Code: {gigBillData[0]?.stateCode}
                      <br />
                      Reverse charges applicable:{" "}
                      {gigBillData[0]?.buyer?.reverseChargesApplicable}
                      <br />
                      GSTIN:{" "}
                      {gigBillData[0]?.buyer?.gst
                        ? gigBillData[0]?.buyer?.gst
                        : "NA"}
                    </td>

                    {/* <tr>
                      <td
                        style={{
                          border: "none",
                          padding: "4px 8px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Reference BOS No :
                      </td>
                      <td style={{ border: "none", padding: "4px 8px" }}>
                        {debitNumber}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          border: "none",
                          padding: "4px 8px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Reference BOS Date :
                      </td>
                      <td style={{ border: "none", padding: "4px 8px" }}>
                        {moment(gigBillData[0]?.billingDate)
                          .utc()
                          .format("dddd, MMMM D, YYYY")}
                      </td>
                    </tr> */}
                    <tr>
                      <td
                        style={{
                          border: "none",
                          padding: "4px 8px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Payment Due Date :
                      </td>
                      <td style={{ border: "none", padding: "4px 8px" }}>
                        {moment(gigBillData[0]?.billingDate)
                          .utc()
                          .add(
                            parseInt(gigBillData[0]?.buyer?.paymentDueDate),
                            "days"
                          )
                          .format("MMMM D, YYYY")}
                      </td>
                    </tr>
                  </tr>
                  <tr>
                    <th className="textAlignmentCenter">S.no.</th>
                    <th className="textAlignmentCenter">
                      Description of Service
                    </th>
                    <th className="textAlignmentCenter">Amount</th>
                  </tr>
                  <tr>
                    <td className="textAlignmentCenter">1</td>
                    <td className="textFit">
                      Convenience fee of the month of{" "}
                      {moment(gigBillData[0]?.billingDate)
                        .utc()
                        .format("MMMM YYYY")}
                    </td>

                    <td
                      style={{
                        textAlign: "right",
                        margin: "0px",
                        padding: "0px",
                      }}
                    >
                      <img
                        src={RupeesSymbol}
                        alt="Rupees"
                        style={{
                          height: "23px",
                          width: "23px",
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      />
                      <span
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      >
                        {gigBillData[0]?.convensionFee.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Sub Total</td>

                    <td
                      style={{
                        textAlign: "right",
                        margin: "0px",
                        padding: "0px",
                      }}
                    >
                      <img
                        src={RupeesSymbol}
                        alt="Rupees"
                        style={{
                          height: "23px",
                          width: "23px",
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      />
                      <span
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      >
                        {gigBillData[0]?.convensionFee.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </td>
                  </tr>

                  {!gigBillData[0]?.cgst || !gigBillData[0]?.sgst ? (
                    <>
                      <tr>
                        <td colSpan={2}>
                          <b>Add: CGST @ 9%</b>
                        </td>
                        <td className="textAlignmentRight">{"-"}</td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <b>Add: SGST @ 9%</b>
                        </td>
                        <td className="textAlignmentRight">{"-"}</td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <b>Add: IGST @ 18%</b>
                        </td>
                        {/* <td className="textAlignmentRight">
                          ₹ {gigBillData[0]?.gst}
                        </td> */}
                        <td
                          style={{
                            textAlign: "right",
                            margin: "0px",
                            padding: "0px",
                          }}
                        >
                          <img
                            src={RupeesSymbol}
                            alt="Rupees"
                            style={{
                              height: "23px",
                              width: "23px",
                              display: "inline-block",
                              verticalAlign: "middle",
                            }}
                          />
                          <span
                            style={{
                              display: "inline-block",
                              verticalAlign: "middle",
                            }}
                          >
                            {gigBillData[0]?.gst.toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </span>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      <tr>
                        <td colSpan={2}>
                          <b>Add: CGST @ 9%</b>
                        </td>
                        {/* <td className="textAlignmentRight">
                          ₹ {gigBillData[0]?.cgst}
                        </td> */}
                        <td
                          style={{
                            textAlign: "right",
                            margin: "0px",
                            padding: "0px",
                          }}
                        >
                          <img
                            src={RupeesSymbol}
                            alt="Rupees"
                            style={{
                              height: "23px",
                              width: "23px",
                              display: "inline-block",
                              verticalAlign: "middle",
                            }}
                          />
                          <span
                            style={{
                              display: "inline-block",
                              verticalAlign: "middle",
                            }}
                          >
                            {gigBillData[0]?.cgst.toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <b>Add: SGST @ 9%</b>
                        </td>
                        {/* <td className="textAlignmentRight">
                          ₹ {gigBillData[0]?.sgst}
                        </td> */}
                        <td
                          style={{
                            textAlign: "right",
                            margin: "0px",
                            padding: "0px",
                          }}
                        >
                          <img
                            src={RupeesSymbol}
                            alt="Rupees"
                            style={{
                              height: "23px",
                              width: "23px",
                              display: "inline-block",
                              verticalAlign: "middle",
                            }}
                          />
                          <span
                            style={{
                              display: "inline-block",
                              verticalAlign: "middle",
                            }}
                          >
                            {gigBillData[0]?.sgst.toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <b>Add: IGST @ 18%</b>
                        </td>
                        <td className="textAlignmentRight">{"-"}</td>
                      </tr>
                    </>
                  )}

                  <tr>
                    <td colSpan={2}>
                      <b>Total</b>
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        margin: "0px",
                        padding: "0px",
                      }}
                    >
                      <img
                        src={RupeesSymbol}
                        alt="Rupees"
                        style={{
                          height: "23px",
                          width: "23px",
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      />
                      <span
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      >
                        {invoiceAmount.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="invoiceFooter">
                <b>
                  Note <br /> * TDS to be deducted at @{" "}
                  {gigBillData[0]?.branch?.tds
                    ? gigBillData[0]?.branch?.tds
                    : 2}
                  % under {gigBillData[0]?.branch?.tds === 10 ? "194J" : "194C"}
                </b>
                <br />
                <br />
                <b>Terms & Conditions:</b>
                <div className="invoiceList">
                  <ol
                    style={{
                      listStyleType: "upper-roman",
                      paddingLeft: "20px",
                    }}
                  >
                    <li>Subject to 'Delhi' Jurisdiction only.</li>
                    <li>Please send the relevant TDS Certificate asap.</li>
                    <li>Service Accounting Code: {gigBillData[0]?.sac}.</li>
                    <li>
                      Late Payment Fees of 1.5% per month would be charged after
                      due date.
                    </li>
                    <li>
                      Invoice raised will be deemed to be correct and accepted
                      by you unless any discrepancy is reported to us in
                      written, within 7 days from the date of receipt of the
                      Invoice.
                    </li>
                  </ol>
                </div>

                {/* <div class="invoiceList">
                  <div class="numberedItem">
                    Subject to Delhi Jurisdiction only
                  </div>
                  <div class="numberedItem">
                    TDS certificate to be shared as soon as it is generated
                  </div>
                  <div class="numberedItem">
                    Service Accounting Code: {gigBillData[0]?.sac}
                  </div>
                  <div class="numberedItem">
                    Late Payment Fees of 1.5% per month would be charged after
                    the due date
                  </div>
                  <div class="numberedItem">
                    Invoice raised will be deemed correct and accepted by you,
                    unless any discrepancy is reported to us in writing, within
                    7 days from the date of receipt of the Invoice.
                  </div>
                </div> */}

                <div>
                  <p className="pStyle">For IFAN Flex Pvt. Ltd.</p>
                  <img
                    src={authoritySignature}
                    alt="logosign"
                    className="logosStyle"
                  />
                  <p className="footerText">
                    No Signature required as it's a system generated Tax Invoice
                  </p>
                </div>

                <hr />
                <div className="footerStyle">
                  <p>Office: +91 124.487 5800</p>
                  <p>Fax : +91 124.401 4035</p>
                  <p>CIN: U74999DL2020PTC373866</p>
                </div>
              </div>

              <br />
            </MDBox>
          </Paper>
        </div>
      </DashboardLayout>
    </>
  );
};

export default GigBillTax;



//  <div style="display: flex; justify-content: space-between; padding: 3px 0;">
//     <span>Reference BOS No :</span>
//     <span>${debitNumber}</span>
//   </div>
//   <div style="display: flex; justify-content: space-between; padding: 3px 0;">
//     <span>Reference BOS Date :</span>
//     <span>${moment(gigBillData[0]?.billingDate)
//       .utc()
//       .format("dddd, MMMM D, YYYY")}</span>
//   </div>